// tslint:disable-next-line: prettier
import React from 'react';
export var SolutionPageCtx = React.createContext(null);
//# sourceMappingURL=solution-page-context.js.map